<p-accordionTab
  class="fractional"
  [selected]="false"
  *ngIf="linePendingOrdersModel?.ordersByType?.length > 0"
>
  <p-header>
    <div class="row n-p">
      <div class="col-12">
        <h6 class="title">{{ contentData?.pendingOrders }}</h6>
      </div>
    </div>
  </p-header>
  <div class="p-content">
    <div *ngFor="let order of linePendingOrdersModel?.ordersByType; let idx = index">
      <p class="bold" [class.m-t-lg]="idx !== 0">{{ order?.label }} ({{ order?.value?.length }})</p>
      <div *ngFor="let orderType of order?.value; let ind = index">
        <p class="m-t-sm">
          <a
            (click)="goToOrderSummary(orderType.orderId)"
            id="cta-default-26_{{ ind }}"
            href="javascript:void(0)"
            aria-label="Clickable action"
            >{{ contentData?.order }} # {{ orderType?.orderId }}</a
          >
        </p>
      </div>
    </div>
  </div>
</p-accordionTab>
